<template>
	<div class="input-ext-ui">
		<component
			v-for="(c, cI) in extendedInputExtComponents"
			:is="c.component"
			:key="c.pluginName + '-' + c.componentName"
			:msgBody="msgBodyC"
			:selectionStart="selectionStart"
			:selectionEnd="selectionEnd"
			:selection="selection"
			@update:msgBody="updateMsgBody($event)"
			@update:addSnippet="updateAddSnippet($event)"
			@update:active="updateActive(cI, $event)"
		/>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
	name: 'InputExtUI',
	props: {
		msgBody: {
			type: String,
			default: ''
		},
		selectionStart: Number,
		selectionEnd: Number,
		selection: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			activeComponents: []
		};
	},
	computed: {
		msgBodyC() {
			return this.msgBody;
		},
		extendedInputExtComponents() {
			let rtrn = this.inputExtComponents();

			this.activeComponents = [];

			for (let cI = 0; cI < rtrn.length; cI++) {
				this.activeComponents.push(false);
			}

			return rtrn;
		},
		anyActiveComponent() {
			let rtrn = false;

			for (let cI = 0; cI < this.activeComponents.length; cI++) {
				if (this.activeComponents[cI]) {
					rtrn = true;
					break;
				}
			}

			return rtrn;
		},
		...mapGetters(['inputExtComponents'])
	},
	methods: {
		updateMsgBody(nMsgBody) {
			this.$emit('update:msgBody', nMsgBody);
		},
		updateAddSnippet(snippet) {
			this.$emit('update:addSnippet', snippet);
		},
		updateActive(cI, to = false) {
			this.activeComponents[cI] = !!to;
			this.$emit('update:active', to ? true : this.anyActiveComponent);
		}
	}
};
</script>
